import accountsHanlders from './accounts-api-patch-handler';
import connectorHanlders from './connector-api-patch-handler';

export default [...accountsHanlders, ...connectorHanlders];
